import React from "react";
import styled from "@emotion/styled";
import { FormattedMessage } from "react-intl";
import enUSMsg from "@/utils/languages/en-us.json";

const Text = styled.span(({ theme, fontSize, color }) => ({
  fontFamily: theme.fontFamily.primaryFont,
  fontWeight: theme.fontWeight.medium,
  fontSize: fontSize ? fontSize : "2rem",
  color: color ? color : theme.color.base_black,
}));

const MediumText = ({ id, children, fontSize, color, className }) => {
  return (
    <Text fontSize={fontSize} color={color} className={className}>
      {id && <FormattedMessage id={id} defaultMessage={enUSMsg[id]} />}

      {children}
    </Text>
  );
};

export default MediumText;
